var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "component" },
    [
      _vm._t("default", null, {
        scrolled: _vm.scrolled,
        canScroll: _vm.canScroll,
        scrolledTop: _vm.scrolledTop,
        scrolledBottom: _vm.scrolledBottom
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }